import angular from 'angular';
import * as R from 'ramda';
import moment from 'moment';

export default function EditFindingDocumentDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  amDataService,
  ssDialogService
) {
  const vm = this;

  vm.isSaving = false;

  vm.newAttachment = angular.copy(vm.document);
  vm.documentPresent = true;
  vm.isEdit = vm.newAttachment.findingDocumentId > 0;

  if (!R.isNil(vm.newAttachment.completedDate)) {
    vm.completedDate = moment(vm.newAttachment.completedDate);
  }

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleDocumentAttachmentFileAdd = _handleDocumentAttachmentFileAdd;
  vm.handleFormSubmit = _handleFormSubmit;

  activate();

  function activate() {
    if (vm.newAttachment.displayName) {
      vm.newAttachment.name = vm.newAttachment.displayName;
    }

    vm.completedCurrentDate = moment().add(0, 'days');
    vm.completedMaxDate = vm.completedCurrentDate;
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  // eslint-disable-next-line no-unused-vars
  function _handleDocumentAttachmentFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.selectedFile = $file;
    vm.documentPresent = true;
    // console.log($files);
    // console.log($file);
    // console.log($newFiles);
    // console.log($duplicateFiles);
    // console.log($invalidFiles);
    // console.log($event);
  }

  function _handleFormSubmit() {
    if (_isValid()) {
      vm.isSaving = true;
      const findingId = vm.finding.findingId;
      const findingDocumentId = vm.newAttachment.findingDocumentId;
      const displayName = vm.newAttachment.name;
      let fileName = '';
      if (vm.newAttachment.file) {
        fileName = vm.newAttachment.file.name;
      }

      const promises = [
        amDataService.checkFindingDocumentDisplayNameExists(findingId, findingDocumentId, displayName),
      ];

      if (fileName) {
        // eslint-disable-next-line max-len
        promises.push(amDataService.checkFindingDocumentFileNameExists(findingId, findingDocumentId, fileName));
      }

      $q.all(promises).then((response) => {
        const displayNameExists = response[0].data.result;
        let fileNameExists = false;
        if (fileName) {
          // eslint-disable-next-line no-const-assign
          fileNameExists = response[1].data.result;
        }

        if (displayNameExists) {
          $scope.editFindingDocumentForm.documentName.$invalid = true;
          $scope.editFindingDocumentForm.documentName.$error = { duplicate: true };
          vm.isValid = false;
        } else {
          $scope.editFindingDocumentForm.documentName.$invalid = false;
          $scope.editFindingDocumentForm.documentName.$error = '';
        }

        if (fileNameExists) {
          vm.fileNameIsInvalid = true;
          vm.isValid = false;
        } else {
          vm.fileNameIsInvalid = false;
        }

        if ((!displayNameExists) && (!fileNameExists)) {
          const justEditMetadata = vm.isEdit && !vm.newAttachment.file;
          const dfdSave = $q.defer();

          if (!R.isNil(vm.completedDate)) {
            vm.newAttachment.completedDate = moment(vm.completedDate).format('YYYY-MM-DD');
          } else {
            vm.newAttachment.completedDate = null;
          }

          if (justEditMetadata) {
            // Just editing metadata, no upload needed
            amDataService.updateFindingDocument(vm.newAttachment).then(dfdSave.resolve);
          } else {
            // New file is supporting document
            amDataService.uploadFindingDocument(vm.finding.findingId, vm.newAttachment).then(dfdSave.resolve);
          }

          dfdSave.promise.then(() => {
            vm.isSaving = false;
            alerts.success('The Document  has been saved successfully.');
            $rootScope.$broadcast('refreshAMFindingDocuments', { findingId: vm.finding.findingId });
            _closeDialog();
          });
        } else {
          vm.isSaving = false;
        }
      });
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingDocumentDialog);
  }

  function _isValid() {
    let isValid = true;
    if (vm.newAttachment.file || vm.newAttachment.documentId) {
      vm.documentPresent = true;
    } else {
      isValid = false;
      vm.documentPresent = false;
    }

    if ($scope.editFindingDocumentForm.$invalid) {
      isValid = false;
    }

    return isValid;
  }
}

EditFindingDocumentDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'amDataService',
  'ssDialogService'
];
